var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-thanksgiving_dining",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "sectionTitleImage",
              fn: function () {
                return [
                  _c("h2", [
                    _c("img", {
                      staticClass: "menu--section_logo",
                      attrs: {
                        src: "/library/images/menu/header-thanksgiving-2025.png",
                        alt: "Thanksgiving",
                      },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1347178002
        ),
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-thanksgiving_dining",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u([
          {
            key: "sectionTitleImage",
            fn: function () {
              return [
                _c("h2", [
                  _c("img", {
                    staticClass: "menu--section_logo",
                    attrs: {
                      src: "/library/images/menu/header-thanksgiving-2025.png",
                      alt: "Thanksgiving",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }